import _ from 'lodash'
import highlight from 'scoreboard/components/highlight'
import i18n from 'scoreboard/components/i18n'
import isGeographicOrRollup from 'scoreboard/datasets/is-geographic-or-rollup'

/**
 * Generates a label for the "include descendants" checkbox (if it should
 * be displayed). Note that this returns properly escaped HTML, and can be
 * directly added to the DOM with $.html() instead of $.text()
 *
 * @param {Dataset} dataset
 * @param {Organization} metricOrganization
 *
 * @returns the label to use for the checkbox, or null if the checkbox should
 * not be displayed
 */
function includeDescendantsInputLabel ({ dataset, metricOrganization }) {
	// Only show the checkbox if metric is (or will be) part of a dataset template,
	// and the field used to build the template is a rollup field
	let show = false
	let templateDatasetField
	if (!_.isNil(metricOrganization.datasetFieldId) && _.isNil(metricOrganization.templateId)) {
		templateDatasetField = dataset.getUnderlyingField(metricOrganization.datasetFieldId)
		if (templateDatasetField && isGeographicOrRollup(templateDatasetField.dataType)) {
			show = true
		}
	}

	if (show) {
		// Note: highlight() takes care of HTML escaping the field's label
		let fieldLabel = highlight(templateDatasetField.label)

		return i18n.get('datasets.metric.includeDescendants', fieldLabel)
	} else {
		return null
	}
}

export default includeDescendantsInputLabel

includeDescendantsInputLabel.__filename__ = 'scorecards/edit/include-descendants-input-label.js'
